import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const SupportIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      stroke={props.color ?? '#3379BD'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.5 9.603c.202-.535.6-.985 1.123-1.272a2.732 2.732 0 0 1 1.74-.296 2.62 2.62 0 0 1 1.532.819c.392.433.606.982.605 1.549 0 1.599-2.573 2.398-2.573 2.398M11.996 16h.008M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065c.432-.51.752-1.118.923-1.785.155-.602-.154-1.194-.586-1.64C3.859 16.023 3 14.104 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
    />
  </Svg>
);
export default SupportIcon;
